import * as tf from '@tensorflow/tfjs'
import dataset from './dataset'
import Utils from './utils';

const training = {
  bestModelPath: {
    eye: 'localstorage://best-model-eye',
    head: 'localstorage://best-model-head'
  },
  currentModel: {
    eye: null,
    head: null
  },
  loaded: false,
  inTraining: false,
  epochsTrained: 0,

  createModel: function (inputShape) {
    console.log(inputShape)
    const inputImage = tf.input({
      name: 'image',
      // shape: [478, 3],
      // shape: [40, 3],
      shape: [inputShape[1], inputShape[2]],  //eye+face+eye
    });


    const flat = tf.layers.flatten().apply(inputImage);

    const dropout = tf.layers.dropout(0.2).apply(flat);

    // const concat = tf.layers.concatenate().apply([dropout, inputMeta]);

    const dense = tf.layers
      .dense({
        units: 100,
        activation: 'tanh',
        kernelInitializer: 'varianceScaling',
      }).apply(dropout);
    const output = tf.layers
      .dense({
        units: 2,
        activation: 'tanh',
        kernelInitializer: 'varianceScaling',
      }).apply(dense);

    const model = tf.model({
      inputs: inputImage,
      outputs: output,
    });

    return model;
  },

  loadModel: async function () {
    training.currentModel['eye'] = await tf.loadLayersModel(training.bestModelPath['eye']);
    training.currentModel['head'] = await tf.loadLayersModel(training.bestModelPath['head']);
    training.loaded = true;
  },

  fitModel: async function (model, data_train, data_val) {
    // TODO Set params in UI?
    training.inTraining = true;
    training.epochsTrained = 0;
    const epochs = 100;
    let batchSize = Math.floor(data_train.n * 0.1);
    batchSize = Math.max(2, Math.min(batchSize, 64));
    if (training.currentModel[model] == null)
      training.currentModel[model] = training.createModel(data_train.x.shape);


    console.info('Training on', data_train.n, 'samples');

    let bestEpoch = -1;
    let bestTrainLoss = Number.MAX_SAFE_INTEGER;
    console.log('Best model path:', bestTrainLoss);
    let bestValLoss = Number.MAX_SAFE_INTEGER;

    training.currentModel[model].compile({
      optimizer: tf.train.adam(0.0001),
      loss: 'meanSquaredError',
    });

    training.currentModel[model].fit(data_train.x, data_train.y, {
      batchSize: batchSize,
      epochs: epochs,
      shuffle: true,
      validationData: [data_val.x, data_val.y],
      callbacks: {
        onEpochEnd: async function (epoch, logs) {
          console.info('Epoch', epoch, 'losses:', logs);
          training.epochsTrained += 1;
          // ui.setContent('n-epochs', training.epochsTrained);
          // ui.setCalibrateProgress(parseInt(epoch*100/epochs) );
          // ui.setContent('train-loss', logs.loss.toFixed(5));
          // ui.setContent('val-loss', logs.val_loss.toFixed(5));

          if (logs.val_loss < bestValLoss) {
            // Save model
            bestEpoch = epoch;
            bestTrainLoss = logs.loss;
            bestValLoss = logs.val_loss;

            // Store best model:
            await training.currentModel[model].save(training.bestModelPath[model]);
          }
          return await tf.nextFrame();
        },
        onTrainEnd: async function () {
          console.info('Finished training');
          // Load best model:
          training.epochsTrained -= epochs - bestEpoch;
          console.info('Loading best epoch:', training.epochsTrained);
          training.currentModel[model] = await tf.loadLayersModel(training.bestModelPath[model]);
          training.inTraining = false;
        },
      },
    });
    while (training.inTraining) {
      await Utils.sleep(100);
    }
  },
  trainModel: async function () {
    // training.fitModel(training.currentModelHead, dataset.head_train,dataset.head_val, training.bestModelPathHead);
    await training.fitModel('eye', dataset.eye_train, dataset.eye_val);
    await training.fitModel('head', dataset.head_train, dataset.head_val);
    training.loaded = true;
  },

  resetModel: function () {
    training.currentModel['eye'] = null;
    training.currentModel['head'] = null;
  },




  getPrediction: async function (face) {
    // Return relative x, y where we expect the user to look right now.
    const eyes = dataset.getExampleEyeArr(face);
    const predictionEye = training.currentModel['eye'].predict(eyes);
    const eyeData = await predictionEye.data();
    const head = dataset.getExampleHeadArr(face);
    const predictionHead = training.currentModel['head'].predict(head);
    const headData = await predictionHead.data();
    tf.dispose([eyes, predictionEye,head, predictionHead]);

    const eye_ratio = 1.5;
    const head_ratio = 0.5;

    return [Math.max(0, Math.min((eyeData[0]*eye_ratio+headData[0]*head_ratio) + 0.5, 1)),
    Math.max(0, Math.min((eyeData[1]*eye_ratio+headData[1]*head_ratio) + 0.5, 1))];
  },

};

export default training;